<template>
    <router-view />
</template>


<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";

export default {
    data() {
        return {
            scale: 14,
        }
    },
    async mounted() {
        document.documentElement.style.fontSize = this.scale + 'px';

        const userStore = useUserStore();

        if (userStore.accessToken) {
            try {
                await UserService.getUserPing();
                console.log("Session is still valid on the server.");
            } catch (error) {
                console.log("Server validation failed. Logging out.");
                userStore.logout();
                this.$router.push({name: 'Login'});
            }
        }
    }
};
</script>

<style lang="scss">
@import './assets/styles/app/layout.scss';
</style>
